<ion-header>
  <ion-toolbar color="primary">
    <ion-title i18n>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" />
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    @if (type !== 'SITE' && (type === 'LR_PH' ? enableLrPhFilters : emplacementSite?.installations)) {
      <ion-item class="no-lines">
        @if (type === 'LR_PH') {
          <ion-label color="primary" i18n>Libelle installations (avec LR et PH)</ion-label>
        } @else {
          <ion-label color="primary" i18n>Installations</ion-label>
        }
      </ion-item>
      <ion-item
        lines="full"
        (click)="libellesInstallationsFilterValues().length > 1 && openLibellesInstallationsFilter()"
      >
        @if (selectedLabels().fullLibelleInstallation.length >= 1) {
          <crt-text-truncated
            [text]="
              selectedLabels().fullLibelleInstallation
                | crtHierarchyFilterValues: libellesInstallationsFilterValues().length
            "
            [crop]="15"
          />
        } @else {
          <ion-label i18n>Aucune installation sélectionnée</ion-label>
        }
        @if (libellesInstallationsFilterValues().length > 1) {
          <ion-icon name="chevron-down" slot="end" />
        }
      </ion-item>
      <!--filtre niveaux métier -->
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Sélection objets hiérarchiques et métier</ion-label>
      </ion-item>
      <ion-item lines="full" (click)="multiOmChevronDisplay() && openBusinessObjectFilter()">
        @if (selectedLabels().descriptionMetier.length > 0) {
          @if (selectedLabels().descriptionMetier.length === 1) {
            <ion-label>{{ selectedLabels().descriptionMetier[0] }}</ion-label>
          } @else {
            <ion-label>{{ selectedLabels().descriptionMetier.length }} objet(s) métier sélectionné(s)</ion-label>
          }
        } @else {
          <ion-label i18n>Aucun objet métier sélectionné</ion-label>
        }
        @if (multiOmChevronDisplay()) {
          <ion-icon name="chevron-down" slot="end" />
        }
      </ion-item>
      @if (type === 'LR_PH') {
        <ion-item class="no-lines">
          <ion-label color="primary" i18n>Type</ion-label>
        </ion-item>
        <crt-slider-selecteur [options]="typeOptions" [(value)]="typeValue" />
      }
      @if (type === 'CRT_DATA' || type === 'LR_DATA' || type === 'CRT_HISTORIC') {
        <ion-item class="no-lines">
          <ion-label color="primary" i18n>Type</ion-label>
        </ion-item>
        <ion-item lines="full" class="capitalize" (click)="typeFilterValues().length > 1 && openTypeFilter()">
          @if (selectedLabels().type.length > 0) {
            @if (typeFilterValues().length === 1 && selectedLabels().type.length === 1) {
              <ion-label>{{ selectedLabels().type[0] }}</ion-label>
            } @else {
              <ion-label>{{ selectedLabels().type | crtTypeFilterValuesPipe: typeFilterValues().length }}</ion-label>
            }
          } @else {
            <ion-label i18n>Aucun type sélectionné</ion-label>
          }
          @if (typeFilterValues().length > 1) {
            <ion-icon name="chevron-down" slot="end" />
          }
        </ion-item>
      }
    }
    @if (!isFiltreHistorique && type !== 'EVENTS') {
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Statut</ion-label>
      </ion-item>
      @if (type === 'SITE') {
        <crt-slider-selecteur [options]="siteDiscordanceOptions" [(value)]="etatDiscordant" />
      } @else {
        <crt-slider-selecteur [options]="discordanceOptions" [(value)]="discordantOnly" />
      }
      @if (type !== 'LR_PH' && type !== 'SITE') {
        <ion-item class="no-lines">
          <ion-label color="primary" i18n>Mode d'affichage</ion-label>
        </ion-item>
        <crt-slider-selecteur [options]="modeAffichageOptions" [(value)]="isAffichageComplet" />
      }
      @if (type === 'SITE' || type === 'CRT_DATA') {
        <ion-item class="no-lines">
          <ion-label color="primary" i18n>Blocage</ion-label>
        </ion-item>
        <crt-slider-selecteur
          [options]="type === 'SITE' ? blocageSiteOptions : blocageOptions"
          [(value)]="etatBlocage"
        />
      }
    }
    @if (type === 'LR_PH' || type === 'CRT_HISTORIC' || type === 'CRT_DATA') {
      <ion-item class="no-lines">
        @if (type === 'LR_PH') {
          <ion-label color="primary" i18n>Etat de l'objet</ion-label>
        } @else {
          <ion-label color="primary" i18n>Etat de la donnée</ion-label>
        }
      </ion-item>
      <ion-item lines="full" (click)="etatFonctionnelFilterValues().length > 0 && openEtatFonctionnelFilter()">
        @if (hasCheckedEtatFonctionnel()) {
          @if (checkedEtatFonctionnelCount() === etatFonctionnelFilterValues().length) {
            <ion-label i18n>Tous</ion-label>
          } @else if (checkedEtatFonctionnelCount() === 1) {
            <ion-label>{{ singleCheckedEtatFonctionnel().label }}</ion-label>
          } @else {
            <ion-label i18n>{{ checkedEtatFonctionnelCount() }} états sélectionnés</ion-label>
          }
        } @else {
          <ion-label i18n>Aucun état sélectionné</ion-label>
        }
        @if (etatFonctionnelFilterValues().length > 1) {
          <ion-icon name="chevron-down" slot="end" />
        }
      </ion-item>
    }

    @if (type === 'EVENTS') {
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Etats</ion-label>
      </ion-item>
      <crt-slider-selecteur [options]="etatOptions" [(value)]="status" />
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Priorité</ion-label>
      </ion-item>
      <ion-item lines="full" (click)="priorityFilterValues().length > 1 && openPriorityFilter()">
        @if (selectedLabels().priorite.length > 0) {
          @if (priorityFilterValues().length === 1 && selectedLabels().priorite.length === 1) {
            <ion-label>{{ selectedLabels().priorite[0] }}</ion-label>
          } @else {
            <ion-label>{{ selectedLabels().priorite.length }} priorité(s) sélectionnée(s)</ion-label>
          }
        } @else {
          <ion-label i18n>Aucune priorité sélectionnée</ion-label>
        }
        @if (priorityFilterValues().length > 1) {
          <ion-icon name="chevron-down" slot="end" />
        }
      </ion-item>
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Profondeur temporelle</ion-label>
      </ion-item>
      <crt-slider-selecteur [options]="profondeursOptions" [(value)]="temporalWidth" />
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Début et fin de communication</ion-label>
      </ion-item>
      <crt-slider-selecteur [disabled]="!isConnected()" [options]="debutFinCommOptions" [(value)]="showDebutFinComm" />
      <ion-item class="no-lines">
        <ion-label color="primary" i18n>Tri des événements</ion-label>
      </ion-item>
      <crt-slider-selecteur [options]="sortOptions" [(value)]="sort" />
    }
  </ion-list>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-button expand="block" color="danger" (click)="applyFilter()" i18n>
    <ion-label color="white">Appliquer</ion-label>
  </ion-button>
</ion-footer>
